// src/pages/AdminDatosMaestrosPage.js
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { seccionesVisibles, rutaDeLista } from '../components/admin/datosMaestrosListas';
import PageHeader from '../components/ui/PageHeader';
import '../style/pages/HomePage.css';
import '../style/pages/AdminDatosMaestrosPage.css';

const TarjetaDatoMaestro = ({ lista, tono }) => (
    <Link to={rutaDeLista(lista.clave)} className={`dm-tarjeta dm-tono-${tono} rounded-4 shadow-sm`}>
        <span className="dm-tarjeta-icono">
            <i className={`bi ${lista.icono}`} aria-hidden="true"></i>
        </span>
        <h3 className="dm-tarjeta-titulo">{lista.titulo}</h3>
        <p className="dm-tarjeta-descripcion">{lista.descripcion}</p>
        <span className="dm-tarjeta-accion">
            Gestionar
            <i className="bi bi-arrow-right-short" aria-hidden="true"></i>
        </span>
    </Link>
);

/**
 * Panel de Datos Maestros: una grilla de tarjetas por módulo; cada tarjeta lleva a la página
 * de gestión de esa lista (AdminDatosMaestrosListaPage, /admin/datos-maestros/<clave>), con
 * la tabla a ancho completo.
 */
const AdminDatosMaestrosPage = () => {
    const { puede } = useAuth();
    const accesoCompleto = puede('datosMaestros.ver');

    const secciones = useMemo(() => seccionesVisibles(accesoCompleto), [accesoCompleto]);

    return (
        <div className="homepage-container datos-maestros-page area-admin">
            <PageHeader
                variante="plano"
                icono="database-fill-gear"
                titulo="Administración de Datos Maestros"
                descripcion="Administre las opciones disponibles en los menús desplegables del sistema"
            />

            <div className="alert alert-info dm-banner rounded-4 shadow-sm mb-4" role="note">
                <i className="bi bi-info-circle-fill dm-banner-icono" aria-hidden="true"></i>
                <div>
                    <strong className="dm-banner-titulo">¿Para qué sirven los datos maestros?</strong>
                    <p className="mb-2">
                        Son las listas de opciones que aparecen en los menús desplegables del sistema:
                        lugares, abogados, aseguradoras, motivos de rechazo, tipos de turno, etc. Lo que
                        se cargue acá es lo que todo el estudio va a poder elegir al completar trámites,
                        turnos y atenciones, así se evita escribir lo mismo de distintas formas.
                    </p>
                    <ol className="dm-banner-pasos mb-0">
                        <li>Elija en las tarjetas de abajo la lista que quiere modificar.</li>
                        <li>
                            Agregue opciones con el botón <strong>Nuevo</strong>, o use el menú{' '}
                            <i className="bi bi-three-dots-vertical" aria-label="de tres puntos"></i> de
                            cada fila para editarlas o eliminarlas.
                        </li>
                        <li>
                            Si una opción ya no se usa pero quedó cargada en registros anteriores, cuando la
                            lista lo permita desactívela en lugar de eliminarla: deja de ofrecerse y se
                            conserva el historial.
                        </li>
                    </ol>
                </div>
            </div>

            {secciones.map((seccion) => (
                <section key={seccion.clave} className="dm-seccion" aria-labelledby={`dm-seccion-${seccion.clave}`}>
                    <h2 id={`dm-seccion-${seccion.clave}`} className="dm-seccion-titulo">
                        <i className={`bi ${seccion.icono} me-2`} aria-hidden="true"></i>
                        {seccion.titulo}
                    </h2>
                    <hr className="dm-seccion-divisor" />
                    <div className="dm-grilla">
                        {seccion.listas.map((lista) => (
                            <TarjetaDatoMaestro key={lista.clave} lista={lista} tono={seccion.tono} />
                        ))}
                    </div>
                </section>
            ))}
        </div>
    );
};

export default AdminDatosMaestrosPage;
